import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-financial-institution',
  templateUrl: './financial-institution.component.html',
  styleUrls: ['./financial-institution.component.scss']
})
export class FinancialInstitutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/financial-institution/financial-institution.component.ts